import { DELETE, GET, PATCH, POST, POSTSSE, PUT } from "../axios/apiService";

export const getSavedCRMConfig = async ({ options, crmConfigId, crmKey }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspace-settings/integrations/${crmConfigId}/${crmKey}/configuration/objects`;
  return GET(url, options);
};

export const searchCRMRecords = async ({ data, options = {}, configId, onStream }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/batch/search`;

  return POSTSSE(url, data, {
    ...options,
    onStream,
    withCredentials: false,
    skipErrorToast: true,
  });
};

export const getCRMRecords = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/bulk-records`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};

export const findDiffInCRMRecords = async ({ data, options = {}, configId, onStream }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/analyse-record`;

  return POSTSSE(url, data, {
    ...options,
    onStream,
    withCredentials: false,
    skipErrorToast: true,
  });
};

export const createCRMRecords = async ({ data, options = {}, configId, onStream }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/batch/create`;

  return POSTSSE(url, data, {
    ...options,
    onStream,
    withCredentials: false,
    skipErrorToast: true,
  });
};

export const createCRMRecordsB = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/batch/create`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};

export const matchCRMRecord = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/match`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};
export const updateCRMRecord = async ({ data, options, configId }) => {
  const url = `${process.env.REACT_APP_API_SURGE_BASE_URL}/api/v1/crm/${configId}/update`;
  return POST(url, data, {
    withCredentials: false,
    ...options,
  });
};

export const setWorkspacePreferences = async ({ data, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/api/v1/workspaces/user/preferences`;
  return PATCH(url, data, options);
};
